module.exports = __webpack_public_path__ + "static/media/natcap.c6a9c80e.png";